import type { TemplateField } from '../types/entities';
import { isStringArray } from './persistedState';

type FieldTargetMode = 'any' | 'category' | 'template';
export interface BuilderField {
  id?: string;
  originalKind?: string;
  label: string;
  key: string;
  kind: string;
  required: boolean;
  trackable: boolean;
  options: string;
  targetMode: FieldTargetMode;
  allowedCategories: string[];
  allowedTemplates: string[];
}
export function blankField(): BuilderField {
  return {
    label: '', key: '', kind: 'text', required: false, trackable: false, options: '',
    targetMode: 'any', allowedCategories: [], allowedTemplates: []
  };
}
export function fromTemplateField(field: TemplateField): BuilderField {
  return {
    id: field.id,
    originalKind: field.kind,
    label: field.label,
    key: field.key,
    kind: field.kind,
    required: field.required,
    trackable: field.trackable,
    options: isStringArray(field.validation.options) ? field.validation.options.join(', ') : isStringArray(field.validation.columns) ? field.validation.columns.join(', ') : '',
    targetMode: field.allowedTemplateKeys.length ? 'template' : field.allowedTemplateCategories.length ? 'category' : 'any',
    allowedCategories: [...field.allowedTemplateCategories],
    allowedTemplates: [...field.allowedTemplateKeys]
  };
}
export function serializeBuilderFields(fields: BuilderField[]): Array<Record<string, unknown>> {
  return fields.filter((field) => field.label && field.key).map((field) => ({
      ...(field.id ? { id: field.id } : {}),
      key: field.key,
      label: field.label,
      kind: field.kind,
      required: field.required,
      trackable: field.trackable,
      filterable: true,
      multiple: ['list', 'tuple-list', 'reference-list', 'tags'].includes(field.kind),
      validation: field.kind === 'select'
        ? { options: field.options.split(',').map((option) => option.trim()).filter(Boolean) }
        : field.kind === 'tuple-list'
          ? { columns: field.options.split(',').map((column) => column.trim()).filter(Boolean) }
          : {},
      allowedTemplateCategories: field.targetMode === 'category' ? field.allowedCategories : [],
      allowedTemplateKeys: field.targetMode === 'template' ? field.allowedTemplates : []
    }));
}
